import { fetchAuthSession, signOut } from 'aws-amplify/auth';

let monitorInterval: NodeJS.Timeout | null = null;
const CHECK_INTERVAL = 60000; // Check every 60 seconds

export const startAuthMonitor = (onSessionExpired?: () => void) => {
  if (monitorInterval) {
    return; // Already monitoring
  }

  monitorInterval = setInterval(async () => {
    // Don't redirect if user is on public pages
    const publicPaths = ['/login', '/signup', '/'];
    const currentPath = window.location.pathname;
    const isPublicPage = publicPaths.some(path => currentPath.startsWith(path));
    
    try {
      const session = await fetchAuthSession();
      const idToken = session.tokens?.idToken;
      
      if (!idToken) {
        // Only handle session expiry if user was authenticated and is on a protected page
        if (!isPublicPage) {
          console.warn('⚠️ Auth session expired - signing out');
          await handleSessionExpired(onSessionExpired);
        }
        return;
      }

      // Check if token is expired by decoding JWT
      try {
        const tokenString = idToken.toString();
        const payload = JSON.parse(atob(tokenString.split('.')[1]));
        const expirationTime = payload.exp * 1000; // Convert to milliseconds
        const currentTime = Date.now();
        
        if (currentTime >= expirationTime) {
          console.warn('⚠️ Auth token expired - signing out');
          await handleSessionExpired(onSessionExpired);
        }
      } catch (error) {
        console.error('Error checking token expiration:', error);
      }
    } catch (error) {
      // Only handle auth check failures if user is on a protected page
      if (!isPublicPage) {
        console.warn('⚠️ Auth session check failed - signing out');
        await handleSessionExpired(onSessionExpired);
      }
    }
  }, CHECK_INTERVAL);
};

export const stopAuthMonitor = () => {
  if (monitorInterval) {
    clearInterval(monitorInterval);
    monitorInterval = null;
  }
};

const handleSessionExpired = async (onSessionExpired?: () => void) => {
  stopAuthMonitor();
  
  try {
    await signOut();
  } catch (error) {
    console.error('Error during sign out:', error);
  }
  
  // Clear local storage
  sessionStorage.clear();
  localStorage.removeItem('selectedVendorId');
  
  if (onSessionExpired) {
    onSessionExpired();
  } else {
    // Default: redirect to login
    window.location.href = '/login';
  }
};
